import {IComponentController, IComponentOptions, IRootElementService, IScope} from "angular";
import './ordering-list.component.scss';
import {Sorting} from "../components/sorting";

export class OrderingListComponent implements IComponentController {

    public static instance: IComponentOptions = {
        template: require('./ordering-list.component.html'),
        controller: ['$scope', '$element', 'dragularService', OrderingListComponent],
        bindings: {
            'orderingListElements': '=',
            'onOrderChange': '<'
        }
    };


    private orderingListElements: Sorting[];
    private onOrderChange: () => void;

    constructor(private $scope: IScope,
                private $element: IRootElementService,
                private dragularService: any) {
    }


    $postLink = () => {
        setTimeout(() => {
            this.initializeDragular();
        }, 100);

    };


    initializeDragular = () => {
        this.dragularService(this.$element, {
            scope: this.$scope,
            containersModel: this.orderingListElements
        });

        this.$scope.$on('dragulardrop', (e, el) => {
            this.onOrderChange();
            e.stopPropagation();
        });
    };

}